import { MerchantUserType } from "../core/merchant.core";
import { LocaleText } from "./locale";
import { Media } from "./media";
import { MerchantUser } from "./merchant";
import { AdminUser } from "./user";

export enum ShopType {
  regular = "regular",
  multiMerchant = "multiMerchant",
}

export type ShopRegType = "email" | "tel" | "emailAndTel";

export type CartItemPrice = "eshopPrice" | "basePrice";

export interface ShopFull extends ShopTiny {
  code: string;
  smtpFrom: string;
  smtpTransport: any;
  rootUrl: string;
  googleKeyClientId: string;
  googleKeySecret: string;
  // stripeKeyClientId: string;
  // paypalKeyClientId: string;
  // stripeTestKeyClientId: string;
  // paypalTestKeyClientId: string;
  shopUsers: AdminUser[];
  merchantUsers: MerchantUser[];
  shipSfEnabled: boolean;
  mobileRedirect: {
    enable: boolean;
    url: string;
  };
  eshopInventoryEnabled: boolean;
  retailInventoryEnabled: boolean;
  eshopWarehouseId: string;
  shipPickupEnabled: boolean;
  shipBasicEnabled: boolean;
  rewardExpireAfter?: number; // in days, if it's not set (null), that means reward function is turned off
  rewardPayout: number;
  rewardRoundOff: RoundOff;
  orderRoundOff: RoundOff;
  posOrderRoundOff: RoundOff;
  accessYouUser: string;
  accessYouAcctNo: string;
  accessYouPw: string;
  otpMsg: string;
  rewardEarnedDeductions: string[];
  rewardAppliesTo: string[];
  couponAppliesTo: string[];
  giftCardAppliesTo: string[];
  membershipAppliesTo: string[];
  membershipDiscountBase: "originalPrice" | "discountPrice" | "membershipPrice";
  cartItemPrice?: CartItemPrice;
  minOrderAmtAfterDeduct: number;
  eshopOrderCancelTime: number;
  defaultRetailOrderCancelTime: number;
  retailOrderCancelTimes: { retailShopId: string; time: number }[];
  timeZone: string;
  addCustomerInfo: string[];
  customerSpendingInfo: boolean;
  regType: ShopRegType;
  recycleEnabled: boolean;
  posOnlineOrderEnabled: boolean;
  combineOrderEnabled: boolean;
  posDeliveryMenuEnabled: boolean;
  preventShipSettingMismatch: boolean;
  orderCreatedEmailDelayMinutes?: number;
}

export interface ShopByCode {
  logo: Media;
  name: string;
}

export interface ShopTiny {
  id: string;
  name: LocaleText;
  locales: string[];
  defaultLocale: string;
  currencies: string[];
  defaultCurrency: string;
  logoMedia: Media;
  userMerchantRole: MerchantUserType;
  userShopRole: ShopUserType;
  shopType: ShopType;
  posEnabled: boolean;
  regType: ShopRegType;
  recycleEnabled: boolean;
}

export interface ShopUser {
  adminUserId: string;
  type: ShopUserType;
}

export enum ShopUserType {
  admin = "admin",
  shopManager = "shopManager",
  retail = "retail",
}

// export enum ShopType {
//   regular = "regular",
//   multiMerchant = "multiMerchant",
// }

export interface OffHoursType {
  _id: string;
  allowedIPs: [];
  restrictOffHourAccess: boolean;
  restrictHours: [
    {
      daysOfWeek: string[];
      openAt: string;
      closeAt: string;
    }
  ];
}

export type RoundOff =
  | "roundUp"
  | "roundDown"
  | "toFixed"
  | "toSignificant"
  | "roundUp1"
  | "roundDown1"
  | "roundHalf1"
  | "roundUp2"
  | "roundDown2";

export interface PosOfficeHoursType {
  allowedIPs: [];
  restrictOffHourAccess: boolean;
  restrictHours: [
    {
      daysOfWeek: string[];
      start: string;
      end: string;
    }
  ];
}

export interface SalesLocation {
  id: string;
  name: LocaleText;
  address: LocaleText;
  openingHour?: string;
  tel?: string;
  whatsapp?: string;
  website?: string;
}
